import * as moment from 'moment-timezone';
import {
  GetNextPasswordValidationAttemptDate,
  GetNextPasswordValidationAttemptDateResult
} from '../../ts/ServerApi/requests/GetNextPasswordValidationAttemptDate';
import {NotifyingFutureActionService} from '../../ts/services/NotifyingFutureActionService';
import {ServiceLocator} from '../../app/ServiceLocator';
import WebHttpClient from '../../httpClient/WebHttpClient';


export function showMessageForUser(username: string, showMessage: (message: string) => void, callback: () => void): void {
  WebHttpClient.sendRequest(new GetNextPasswordValidationAttemptDate(username)).then(
    (result: GetNextPasswordValidationAttemptDateResult) => {
      ServiceLocator.get<NotifyingFutureActionService>('NotifyingFutureActionService').register({
        messageKey: 'passwordLockoutPeriod',
        targetDate: moment(<any>result).toDate(),
        dateArrivedListener: callback,
        showNewMessage: showMessage,
      });
    }
  );
}